import { hoverHeight } from 'components/FilmPage/FilmPageHeadDesktop/styled/index';
import styled from 'styled-components';

export default styled.div`
  height: ${hoverHeight};
  width: 100%;
  position: relative;
`;
